// /v/$id — real route (design doc's G1/G4, public/SEO surface). Mirrors
// apps/web's app/v/[id]/page.tsx: a `'use client'` page reading its own `id`
// via next/navigation's useParams(). Public, no guard — replaces the
// placeholderRoute call in routes/core.tsx (ClientLayout already renders
// `/v/` chromeless).
import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';
import { rootRoute } from './__root';

const SharedVisualizationPage = lazy(() => import('@/app/v/[id]/page'));

export const shareVisualizationRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/v/$id',
  component: SharedVisualizationPage,
});
